import { BodyScrollLock } from '../modules/BodyScrollLock';

export default class Modal {
  get CLASSES() {
    return {
      isModalOpened: 'is-modal-opened',
    };
  }

  constructor() {
    this.$trigger = [...document.querySelectorAll('[data-modal-trigger]')];
    this.$modal = [...document.querySelectorAll('[data-modal]')];
    if (!this.$trigger && !this.$modal) return;
    this.$close = [...document.querySelectorAll('[data-modal-action="close"]')];
    this.$overlay = document.querySelector('[data-modal-overlay]');
    this.init();
  }

  init() {
    this.show();
    this.hide();
  }

  show() {
    this.$trigger.forEach((element) => {
      element.addEventListener('click', (event) => {
        BodyScrollLock(true);
        const dataModal = event.currentTarget.getAttribute('data-modal-target');
        this.$overlay.classList.add(this.CLASSES.isModalOpened);
        this.$modal.forEach((modalNode) => {
          if (modalNode.getAttribute('data-modal-id') === dataModal) {
            modalNode.scrollTop = 0;
            modalNode.classList.add(this.CLASSES.isModalOpened);
          }
        });
      });
    });
  }

  hide() {
    this.$close.forEach((element) => {
      element.addEventListener('click', (event) => {
        BodyScrollLock(false);
        const targetModal = event.currentTarget.closest('[data-modal]');
        targetModal.classList.remove(this.CLASSES.isModalOpened);
        this.$overlay.classList.remove(this.CLASSES.isModalOpened);
      });
    });
  }
}
